// Community components exports
export { TierBadge } from './TierBadge';
export { AudioPlayer } from './AudioPlayer';
export { Comment } from './Comment';
export { NotificationBell } from './NotificationBell';
export { DeleteModal } from './DeleteModal';
export { MixUploadModal } from './MixUploadModal';
export { PostCard } from './PostCard';
export { TrackSharePost } from './TrackSharePost';
export { TrackShareModal } from './TrackShareModal';
export { MyPlaylistsTab } from './MyPlaylistsTab';
export { GrowthTracker } from './GrowthTracker';
export { BrandingChallenges } from './BrandingChallenges';
export { ProfileAuditModal, ProfileAuditPost } from './ProfileAuditPost';
export { PressKitBuilder } from './PressKitBuilder';
export { default as SuggestedConnections } from './SuggestedConnections';

// Constants
export const DJ_REACTIONS = ['🎧', '🔥', '🎛️', '💣', '💯', '📀', '👑', '🧠'];

export const POST_TYPES = {
  standard: { label: 'Post', icon: '💬' },
  win: { label: 'DJ Win', icon: '🎉' },
  feedback: { label: 'Feedback Request', icon: '❓' },
  looking_for: { label: 'Looking For', icon: '🤝' },
  admin: { label: 'Announcement', icon: '📌' },
  mix_upload: { label: 'Mix Upload', icon: '🎧' },
  track_share: { label: 'Track Share', icon: '🎵' }
};

export const DJ_GENRES = ['HipHop', 'RnB', 'DnB', 'Garage', 'Tech House', 'Minimal House', 'Afro House', 'Afrobeats', 'Dancehall', 'Reggaeton', 'Soca', 'Other'];

export const SKILL_LEVELS = ['Beginner', 'Intermediate', 'Advanced', 'Professional'];

export const ROOM_ACCESS = {
  starter: ['general', 'beginner-lab', 'local-connections'],
  pro: ['general', 'beginner-lab', 'local-connections', 'mix-feedback', 'dj-growth', 'track-discovery'],
  elite: ['general', 'beginner-lab', 'local-connections', 'mix-feedback', 'dj-growth', 'track-discovery']
};

export const MIX_FEEDBACK_TAGS = [
  { id: 'transitions', label: '🔄 Transitions' },
  { id: 'eq-control', label: '🎚 EQ Control' },
  { id: 'track-selection', label: '🎵 Track Selection' },
  { id: 'energy-flow', label: '⚡ Energy Flow' },
  { id: 'crowd-control', label: '🎤 Crowd Control' },
  { id: 'overall-mix', label: '🔥 Overall Mix' }
];

export const TRACK_GENRES = [
  'House', 'Tech House', 'Deep House', 'Techno', 'Trance', 
  'Drum & Bass', 'Dubstep', 'Hip Hop', 'R&B', 'Afrobeats',
  'Reggaeton', 'Dancehall', 'UK Garage', 'Amapiano', 'Other'
];
